import eventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
import workspace from "../workspace";
import store from "../../../../../../store";
import $ from "jquery";
import {iconPlusGreen} from "../../../../assetsSQFT";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
// import {addResource, changeResource} from "../../../../../../actions/sqftResourceFunctions";
// import { v4 as uuidv4 } from 'uuid';
import {attachResource} from "./resourseCanas";
import {getStringFeatureName} from "../../../../../../misc/helpers";
import {setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import {SIDEBAR_HIDDEN_BUTTONS, SIDEBAR_NAVIGATION_BUTTONS} from "../../../../constants";
import MiteredController from "./mitered";

const edgesCanvas = function() {
	let self = this;

	this.edges = [];
	this.edgeFeature = null;
	this.img = null;
	this.cursorImage = null;
	this.isWaitingToRestoreCursor = false;
	this.addedImages = []; // here we save image for every edge cursor added

  this.setEgeFeature = function(edgeFeature){
    this.edgeFeature = edgeFeature
  };

  this.setHighlighting = function (disallowDemo) {
    eventManager.stealCursor(true); // remove all other cursors
    workspace.setAllowEdges(false); //  removing sizing lines
    workspace.setAllowBumpoutEdges(false); //  removing bumpout lines
    config.highlight.points = false;	// remove radiuses
    config.highlight.lines = true;  // enable lines highlighting
    config.highlight.type = 'edge';
    config.highlight.id = self.edgeFeature.dbFeature.id;

    if (!disallowDemo) {
      config.highlight.demoShow = true;
    }
    setTimeout(function () {
      config.highlight.demoShow = false;
    }, 1000);
  };

  this.setCursorImage = () => {
    const alreadyAddedImage = this.addedImages.find(image => image.dataset.id === this.edgeFeature.dbFeature.id.toString());
    if (alreadyAddedImage) {
      this.cursorImage = { image: alreadyAddedImage, width: alreadyAddedImage.width, height: alreadyAddedImage.height };
      eventManager.setCursor('edge-select', this, true);
      registerEvents();
    } else {
      addCursorImage();
    }
  };

  const addCursorImage = () => {
    let domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";

    let $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });
    $img.attr({
      'data-id': self.edgeFeature.dbFeature.id,
      'data-name': self.edgeFeature.getFeatureName(), //<FeatureName feature={self.edgeFeature}/>,//intl.formatMessage({id: self.edgeFeature.dbFeature.sharedFeatureName}),
      'data-shared-feature-name': self.edgeFeature.getFeatureName(),
    });
    function imgOnLoad() {
      self.addedImages.push(domImg);
      self.setCursorImage();
    }
    $img.on('load', imgOnLoad);
    $img.appendTo($('body'));
    $img.attr('src', iconPlusGreen);
    this.img = $img;
  };

  const registerEvents = () => {
    eventManager.addEvent(
      eventManager.events.RENDER,
      renderCursor,
      this,
      eventManager.priorities.OVERALL
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };

  this.deregisterEvents = () => {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    config.highlight.lines = false;
  }

  this.destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(this, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
      $('img[data-id="' + this.img.data('id') +'"]').remove();
      this.addedImages = this.addedImages.filter(image => image.dataset.id === this.img.data('id'));
    }
  };

  // Function to attach the main and additional resources to the segment
  const attachEdgeResource = (seg, segCorner, edgeFeature, fabricatorData, intl) => {
    let edgeNameTranslated = getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData);

    // 1. Remove incompatible resources
    if (seg && seg.isWithMitered()) {
      seg.deleteMitered();
    } else if (seg && (seg.isWithWaterfallToolEdge() || seg.isWithPeninsulaUnderwrapEdge())) {
      seg.deleteAttachedItem();
    }

    // 2. Attach the new edge resource
    attachResource(seg, segCorner, 'edge', edgeFeature.dbFeature.id, edgeFeature.partId, edgeNameTranslated);

    // 3. Attach additional resources if needed
    attachAdditionalResources(seg, edgeNameTranslated);
  };

  // Function to attach additional resources such as "peninsula underwrap" or "miter underwrap"
  const attachAdditionalResources = (seg, edgeNameTranslated) => {
    const lowerCaseEdgeName = edgeNameTranslated.toLowerCase();

    // Peninsula Underwrap Edge
    if (lowerCaseEdgeName.includes("peninsula underwrap")) {
      if (seg && !seg.isWithPeninsulaUnderwrapEdge()) {
        seg.addPeninsulaUnderwrapToLine();
        store.dispatch(setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.toolWaterfall));
      }
    }

    // Miter Underwrap Edge
    if (lowerCaseEdgeName.includes("miter underwrap")) {
      if (workspace.miteredController === null) {
        workspace.miteredController = new MiteredController();
      }
      workspace.miteredController.attachMiteredUnderwrapEdge(seg);
    }

    // Additional logic for Waterfall, if needed
    // if (lowerCaseEdgeName.includes("waterfall")) {
    //   if (seg && !seg.isWithWaterfallToolEdge()) {
    //     seg.addWaterfallToLine();
    //     store.dispatch(setSQFTMenuOpened(SIDEBAR_HIDDEN_BUTTONS.toolWaterfall));
    //   }
    // }
  };

  const onMouseUp = (mousePos) => {
    void mousePos;
    const hoverShape = workspace.getHoverShape();

    if (hoverShape && hoverShape.getHoverSegment) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;
      const activeSubMenuButton = reduxState.sqftMenuState.activeSubMenuButton;
      if (activeButton === SIDEBAR_NAVIGATION_BUTTONS.edge && activeSubMenuButton !== SIDEBAR_HIDDEN_BUTTONS.buttonMitered) {
        const segCorner = hoverShape.getHoverSegmentOutlineCorner();
        const seg = hoverShape.getHoverSegment();
        const fabricatorData = reduxState.fabricatorState;
        const intl = workspace.intl;

        if (seg || segCorner) {
          attachEdgeResource(seg, segCorner, this.edgeFeature, fabricatorData, intl);

          const updateCalculations = reduxState.sqftState.updateCalculations;
          store.dispatch(updateSQFTCalculations(updateCalculations + 1));
        }

        checkForRestoreCursor();
      }
    }
  };

  const checkForRestoreCursor = () => {
    if (self.isWaitingToRestoreCursor) {
      self.isWaitingToRestoreCursor = false;
      eventManager.removeEvent(this, eventManager.events.MOUSE_UP); //remove mouse up, it will be added in setCursorImage
      this.setHighlighting(true);
      this.setCursorImage();
    }
  };

  const renderCursor = function(ctx) {
    if(self.cursorImage.image && ($(window).width() > 768)) {
      let mPos = eventManager.LastKnownMousePos;
      if(mPos) {
        ctx.drawImage(self.cursorImage.image, mPos.x + 10, mPos.y + 10, 18, 18);
      }
    }
  };
};

export default new edgesCanvas();
